// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { browserLocalPersistence, getAuth, setPersistence } from "firebase/auth";

// Your web app's Firebase configuration.
// NOTE: these values are NOT secrets — for a Firebase web app they are public
// identifiers shipped in the client bundle. Real protection comes from the
// Realtime Database security rules (see database.rules.json) + Authentication.
const firebaseConfig = {
  apiKey: "AIzaSyAKnE-bc6mrhhC3hvw1LfUhIJmjnOJIBxg",
  authDomain: "isidoros-linos.firebaseapp.com",
  databaseURL: "https://isidoros-linos-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "isidoros-linos",
  storageBucket: "isidoros-linos.appspot.com",
  messagingSenderId: "287609982423",
  appId: "1:287609982423:web:69f9b2e15fa1f5387c0f92",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
export const auth = getAuth(app);

// Keep the user signed in across page reloads / app restarts.
setPersistence(auth, browserLocalPersistence);
